import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';
import 'trade-in-360/components/InstantEstimateWrapper/Components/PrivacyPolicy/PrivacyPolicy.scss';

const PrivacyPolicy = () => {
    return (
        <div className="clearfix policy-label fineprint smallprint">
            <span className="policy-icon">
                <icon className="icon-lock" />
            </span>
            <span className="policy-text">
                {LocaleService.t('TRADE_IN.CONTACT.POLICY_TEXT')}
                <a
                    href={REDIRECTIONS[LocaleService.getSimpleLocale()].privacyPolicy}
                    target="_blank"
                    className="policy-link link"
                    rel="noreferrer"
                >
                    {LocaleService.t('TRADE_IN.CONTACT.PRIVACY_POLICY')}
                </a>
            </span>
        </div>
    );
};

PrivacyPolicy.displayName = 'PrivacyPolicy';

export default PrivacyPolicy;
